/**
 * Générateur — Attendu 185 — O3 « Il construit et met en relation une
 * représentation en perspective cavalière et un patron d'une pyramide, d'un
 * cône de révolution. »
 * Niveau : 4ème | Thème #10 Espace (O3) | Domaine : Espace et géométrie.
 * Source prof : « TANOED EXERCISEUR ESPACE ET GEOMETRIE 4EME », O3
 * (Ex.1 perspectives pyramide/cône, natures de faces, patrons de pyramides
 * Ex.2/3).
 *
 * DÉCISIONS (validées, historique) : les « vraies grandeurs » (reconstruction
 * d'une face par Pythagore, Ex.5c/6) relèvent de Pythagore (thème #11), hors
 * O3 ; pas de patron de cône (le cours le marque « pour expert »).
 *
 * Revue 2026-09-23 (vague 4), décisions du coordinateur appliquées en mode
 * auto. Attendu de fin de 4e (Eduscol, attendus de fin d'année) : « Il
 * construit et met en relation une représentation en perspective cavalière
 * et un patron d'une pyramide, d'un cône de révolution. » ; exemples de
 * réussite : « Il représente un cône en perspective cavalière. », « Il
 * réalise le patron d'une pyramide. ». Cours du professeur (19Espace1) :
 * sommet, base, arêtes latérales, hauteur ; le tétraèdre, « une pyramide
 * particulière », dont la base est un triangle ; le cône de révolution,
 * génératrices ; le patron de la pyramide GABC inscrite dans le cube
 * ABCDEFGH (« le triangle ABC rectangle et isocèle en B », « BCG rectangle
 * et isocèle en C », « ACG rectangle en C », « on reporte au compas les
 * longueurs AG et BG »).
 *   - Tous les dessins sont d'un seul jeu, sans sel : les images portaient un
 *     attribut data-v aléatoire qui masquait au harnais une variété réelle de
 *     1 à 6 questions par format ; la variété vient maintenant des
 *     proportions, des lettres et des variantes.
 *   - « Reconnaître le solide » (reconnaitre_qcm_unique) : GARDÉE (mode auto,
 *     À ARBITRER : reconnaître pyramide et cône est au BO 2025 de 4e, l. 999,
 *     mais pas dans les attendus de fin de 4e de 2019, c'est le plafond de
 *     5e). Quatre solides d'un MÊME jeu de dessins sans annotation
 *     (solide185, svgSolides4e.js) : la clé et le cône étaient les seuls
 *     annotés (« S », hauteur rouge) et la clé la seule « rouge sans bleu »
 *     dans 100 % des tirages. Clé variant entre pyramide, tétraèdre et cône ;
 *     jamais le tétraèdre parmi les choix quand on demande « une pyramide »
 *     (il en est une).
 *   - « Nature d'une face » (nature_qcm_unique) : RECADRÉE (mode auto, À
 *     ARBITRER : la nature d'une face est une ligne explicite de 3e, BO 2025
 *     l. 1074 ; en 4e elle se défend comme la vraie forme d'une face, celle
 *     du patron). Figure obligatoire, sommets nommés, UNE face nommée ; choix
 *     « un triangle », « un triangle rectangle », « un carré », « un
 *     rectangle » ; bases à 3 côtés (la pyramide GABC du cours, dans son
 *     cube : ses quatre faces sont des triangles rectangles) ou à 4 côtés
 *     (SABCD à base carrée ou rectangulaire, sommet au-dessus du centre de la
 *     base) ; plus aucune pyramide impossible (2,4 % des tirages avant, bases
 *     octogonales) ; « régulière », « à l'aplomb » et la note en italique
 *     SORTENT ; la réponse n'est plus constante (« des triangles isocèles »
 *     dans 100 % des tirages). La question dit « la nature la plus
 *     précise » : un triangle rectangle est aussi un triangle, un carré aussi
 *     un rectangle (écart à la décision, qui écrivait « la nature », fait pour
 *     que la réponse soit unique). La nature de la face est recalculée sur les
 *     sommets 3D du dessin (longueurs, angle droit par Pythagore), throw si
 *     elle diffère de la clé.
 *   - « Associer solide et patron » (patron_qcm_unique) : GARDÉE, recadrée :
 *     bases triangulaire, carrée ou rectangulaire ; distracteurs de la
 *     famille, sur le modèle de gen_1240 : le patron d'une base qui n'a pas le
 *     même nombre de côtés (nombre_de_triangles), une face qui manque
 *     (face_manquante), une face rabattue sur la base (recouvrement) ; le pavé
 *     et le cylindre, qui s'éliminaient sans regarder (seules deux options
 *     sur quatre avaient une base bleue, 100 %), SORTENT. Figure d'énoncé :
 *     la pyramide nommée, sans hauteur rouge, en imageUrl avec alt ;
 *     « (voir la figure) » retiré.
 *   - « Est-ce un patron ? » (estpatron_qcm_unique) : GARDÉE, corrigée : plus
 *     de face rose (la face rabattue était la seule colorée : « recouvre »
 *     lisible à la couleur dans 100 % des tirages ; correction aussi dans
 *     patronPyramide, pour gen_1240) ; bases à 3 ou 4 côtés (le patron
 *     hexagonal était presque plat) ; NOUVELLE variante aretes_inegales : une
 *     face aux arêtes latérales plus longues, qui ne rejoignent pas celles de
 *     ses voisines (le report au compas du cours) ; figure en imageUrl, alt.
 *   - « Vues de dessus et de face » (vues_qcm_unique) : SORTIE (les vues sont
 *     un attendu de 3e).
 *   - « Compter sommets, arêtes, faces » (denombrer_texte_trou_saisie) :
 *     SORTIE (cycle 3, gen 946).
 *   - NOUVELLE « Le cône en perspective » (cone_qcm_unique), pour « Il
 *     représente un cône en perspective cavalière » : « Quel dessin
 *     représente un cône de révolution en perspective cavalière ? », quatre
 *     dessins du même cône (coneVariante, svgSolides4e.js), un juste et trois
 *     faux parmi quatre : base entièrement en trait plein, pointillés sur la
 *     moitié avant, base dessinée en cercle, sommet décalé ; choix en
 *     imageData (QCM d'images, §1).
 *   - Les pyramides nommées ont toujours leur sommet en S, comme le cours
 *     (« S : le sommet ») ; les lettres de la base sont tirées sans S par
 *     pickLettresSains et gardées avec S (vu en PNG : une base portait S sous
 *     un sommet nommé A). Lettres en KaTeX_Math italique sur les figures.
 *   - Une face rabattue (« recouvre ») n'est dessinée que si elle se voit :
 *     sur une base triangulaire, dès que la face est haute, son apex tombait
 *     sur le sommet opposé et la face se confondait avec la base (l'élève
 *     aurait lu « il manque une face ») ; test recouvrementVisible185.
 *   - Rappel brouillon : aucun (reconnaissance, rien à calculer).
 *   - Contrat des distracteurs exporté (REGLES_DISTRACTEURS_QCM). Aucun
 *     solveur test-side ne couvre ce gen.
 * Cinq formats, tous QCM (trois QCM d'images).
 *
 * ── Révision 2026-09-24 (demandes du prof, validées) ──────────────────────
 *   - Patrons DESSINÉS À L'ÉCHELLE, en cm (patronPyramide185) : faces
 *     latérales nettement isocèles (arête latérale de 1,25 à 1,8 fois le
 *     côté, « écrasée » de 0,7 à 0,85 sur la base triangulaire),
 *     équilatérales une fois sur quatre ; avant, un tirage sur trois (carré)
 *     et deux sur trois (triangle) donnaient des faces presque équilatérales.
 *     CODAGE : les côtés de même longueur portent les mêmes petits traits.
 *   - « Associer solide et patron » : mesures dans l'énoncé (« à base
 *     rectangulaire de 6 cm sur 4 cm ; ses arêtes latérales mesurent 5 cm »)
 *     et sur les quatre patrons, chacun à l'échelle de ses mesures et
 *     remplissant son cadre (une échelle commune rendait minuscules les autres
 *     options dès qu'une arête était longue, vu en PNG) ; pas de face
 *     « écrasée » ici, la pyramide en perspective est dessinée haute ;
 *     nombre_de_triangles
 *     (écarté au premier coup d'œil) est remplacé par autres_mesures, le
 *     patron juste d'une autre pyramide de même base : il faut lire les
 *     mesures, le « met en relation » de l'attendu.
 *   - « Est-ce un patron ? » : codage sur le dessin ; aretes_inegales
 *     toujours sur la base carrée, ses cinq faces, deux faces qui se font
 *     face plus longues (une seule face différente se lisait « il manque sa
 *     jumelle »).
 */

import {
    randomChoice, randInt, shuffle, pickLettresSains, lettresRisquees, makeQcm,
} from '../../../utils';
import {
    patronPyramide185, pyramideNommee185, pyramideDansCube185, elementFigure, choixFigure, recouvrementVisible185,
    rayonBase185,
} from './svgEspace';
import { solide185, coneVariante } from './svgSolides4e';

const ATTENDU_ID = 185;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_RECONN = 'Reconnaître le solide';
const L_NATURE = 'Nature d\'une face';
const L_PATRON = 'Associer solide et patron';
const L_ESTPATRON = 'Est-ce un patron ?';
const L_CONE = 'Le cône en perspective';

/**
 * Le sommet s'appelle toujours S, comme dans le cours (« S : le sommet ») ; les
 * lettres de la base sont tirées sans S (vu en PNG : une base qui portait S sous
 * un sommet nommé A), par pickLettresSains, puis gardées avec S.
 */
const POOL = 'ABCDEFGHJKLMNPRTUV'.split('');
const lettresBase = (n) => {
    for (let essai = 0; essai < 40; essai++) {
        const lettres = pickLettresSains(POOL, n);
        if (!lettresRisquees(['S', ...lettres])) return lettres;
    }
    return ['A', 'B', 'C', 'D'].slice(0, n);                // sûr avec S
};
const NOM_BASE = { triangle: 'triangulaire', carre: 'carrée', rectangle: 'rectangulaire' };

// ═════════ Carte « reconnaître » : QCM d'images ═════════

/** Proportions tirées : la variété d'un QCM d'images est réelle, sans sel. */
const PROPORTIONS = {
    pyramide: () => ({ h: randomChoice([2.6, 3, 3.4]), r: randomChoice([1.4, 1.6]), rot: randomChoice([35, 45, 55]) }),
    tetraedre: () => ({ h: randomChoice([2.4, 2.8, 3.2]), r: randomChoice([1.5, 1.7]), rot: randomChoice([-105, -90, -75]) }),
    prisme3: () => ({ n: 3, h: randomChoice([2.6, 3.2]), r: randomChoice([1.4, 1.6]) }),
    prisme56: () => ({ n: randomChoice([5, 6]), h: randomChoice([2.6, 3.2]), r: randomChoice([1.4, 1.6]) }),
    cone: () => ({ rx: randomChoice([58, 66]), ry: randomChoice([16, 20]), h: randomChoice([140, 155]) }),
    cylindre: () => ({ rx: randomChoice([52, 60]), ry: randomChoice([15, 19]), h: randomChoice([120, 135]) }),
};
const dessiner = (t) => solide185(t.startsWith('prisme') ? 'prisme' : t, PROPORTIONS[t]());

/** Par clé : la question et les trois solides qui incarnent une erreur nommée. */
const RECONNAITRE = {
    pyramide: {
        question: 'Lequel de ces solides est une pyramide ?',
        faux: [{ t: 'cone', code: 'pointu' }, { t: 'prisme3', code: 'triangle_vu' }, { t: 'prisme56', code: 'prisme_pour_pyramide' }],
    },
    tetraedre: {
        question: 'Lequel de ces solides est un tétraèdre ?',
        faux: [{ t: 'pyramide', code: 'pyramide_pour_tetraedre' }, { t: 'prisme3', code: 'triangle_vu' }, { t: 'cone', code: 'pointu' }],
    },
    cone: {
        question: 'Lequel de ces solides est un cône ?',
        faux: [{ t: 'pyramide', code: 'pointu' }, { t: 'tetraedre', code: 'pointu' }, { t: 'cylindre', code: 'base_ronde' }],
    },
};

const genReconnaitre = () => {
    const cle = randomChoice(Object.keys(RECONNAITRE));
    const r = RECONNAITRE[cle];
    // Second chemin : aucun distracteur n'est du type demandé (le tétraèdre n'est jamais
    // proposé quand on demande une pyramide : il en est une).
    if (r.faux.some((f) => f.t === cle || (cle === 'pyramide' && f.t === 'tetraedre'))) throw new Error('gen_185 reconnaitre : seconde bonne réponse');
    const images = [dessiner(cle), ...r.faux.map((f) => dessiner(f.t))].map(choixFigure);
    const payload = makeQcm(images, images[0], `<p><b>${r.question}</b></p>`, opts(L_RECONN));
    payload._meta.params = { cle, distracteurs: r.faux.map((f) => f.code) };
    return payload;
};

// ═════════ Carte « nature » : QCM ═════════

const CHOIX_NATURE = ['un triangle', 'un triangle rectangle', 'un carré', 'un rectangle'];

/** La nature la plus précise d'une face, recalculée sur les sommets 3D du dessin. */
const natureDe = (pts) => {
    const d2 = (a, b) => (a.x - b.x) ** 2 + (a.y - b.y) ** 2 + (a.z - b.z) ** 2;
    const egal = (u, v) => Math.abs(u - v) < 1e-9;
    if (pts.length === 3) {
        const c = [d2(pts[0], pts[1]), d2(pts[1], pts[2]), d2(pts[2], pts[0])].sort((u, v) => u - v);
        return egal(c[0] + c[1], c[2]) ? 'un triangle rectangle' : 'un triangle';
    }
    const cotes = pts.map((p, i) => d2(p, pts[(i + 1) % 4]));
    const angleDroit = pts.every((p, i) => {
        const a = pts[(i + 3) % 4]; const b = pts[(i + 1) % 4];
        return egal((a.x - p.x) * (b.x - p.x) + (a.y - p.y) * (b.y - p.y) + (a.z - p.z) * (b.z - p.z), 0);
    });
    if (!angleDroit) return 'autre';
    return cotes.every((c) => egal(c, cotes[0])) ? 'un carré' : 'un rectangle';
};

/** L'erreur que chaque choix faux incarne, selon la clé. */
const codeNature = (cle, choix) => {
    if (cle === 'un triangle rectangle') return choix === 'un triangle' ? 'moins_precis' : 'face_du_cube';
    if (cle === 'un triangle') return choix === 'un triangle rectangle' ? 'angle_droit_suppose' : 'face_de_l_autre_sorte';
    if (cle === 'un carré') return choix === 'un rectangle' ? 'moins_precis' : 'face_de_l_autre_sorte';
    return choix === 'un carré' ? 'forme_voisine' : 'face_de_l_autre_sorte';
};

const genNature = () => {
    const regime = randomChoice(['cube', 'laterale', 'base']);
    let figure; let face; let intro; let pts;
    if (regime === 'cube') {
        const { svg, alt, sommets } = pyramideDansCube185();
        face = randomChoice(['ABC', 'BCG', 'ACG', 'ABG']);
        pts = [...face].map((l) => sommets[l]);
        figure = elementFigure(svg, alt, 'small');
        intro = '<p>ABCDEFGH est un cube. GABC est la pyramide qui a pour sommets les points G, A, B et C du cube.</p>';
    } else {
        const base = randomChoice(['carre', 'rectangle']);
        const sommet = 'S'; const lettres = lettresBase(4);
        const { svg, alt, sommets } = pyramideNommee185({ base, sommet, lettres });
        const i = randInt(0, 3);
        face = regime === 'base' ? lettres.join('') : `${sommet}${lettres[i]}${lettres[(i + 1) % 4]}`;
        pts = [...face].map((l) => sommets[l]);
        figure = elementFigure(svg, alt, 'small');
        intro = `<p>${sommet}${lettres.join('')} est une pyramide à base ${NOM_BASE[base]}.</p>`;
    }
    // Second chemin : la clé est la nature recalculée sur le dessin.
    const cle = natureDe(pts);
    if (!CHOIX_NATURE.includes(cle)) throw new Error(`gen_185 nature : ${face} ${cle}`);
    const texte = `${intro}<p><b>Quelle est la nature la plus précise de la face ${face} ?</b></p>`;
    const payload = makeQcm(CHOIX_NATURE, cle, texte, { ...opts(L_NATURE), elements_additionnels: figure });
    payload._meta.params = { regime, face, cle, distracteurs: CHOIX_NATURE.filter((c) => c !== cle).map((c) => codeNature(cle, c)) };
    return payload;
};

// ═════════ Carte « patron » : QCM d'images ═════════

// Patrons À L'ÉCHELLE, en cm (révision 2026-09-24, décisions du prof) : faces
// nettement isocèles, équilatérales une fois sur quatre (triangle, carré).
const DIMS_BASE = {
    triangle: () => { const a = randomChoice([3, 4, 5, 6]); return { a, b: a }; },
    carre: () => { const a = randomChoice([3, 4, 5, 6]); return { a, b: a }; },
    rectangle: () => randomChoice([{ a: 6, b: 4 }, { a: 5, b: 3 }, { a: 7, b: 4 }, { a: 8, b: 5 }, { a: 7, b: 5 }]),
};

/**
 * Arêtes latérales entières (cm) d'une base, hors équilatérale : face
 * nettement isocèle, 1,25 à 1,8 fois le côté (et « écrasée », 0,7 à 0,85 fois,
 * sur la base triangulaire) ; rectangle : de R + 0,8 à R + 3,2, R le rayon du
 * cercle circonscrit. Toujours plus que R : la pyramide existe.
 */
const aretesPossibles = (base, { a, b }, ecrasee = false) => {
    const R = rayonBase185(base, a, b);
    const entiers = (min, max) => {
        const out = [];
        for (let l = Math.ceil(min); l <= Math.floor(max); l++) if (l > R + 0.3) out.push(l);
        return out;
    };
    if (base === 'rectangle') return entiers(R + 0.8, R + 3.2);
    const hautes = entiers(1.25 * a, 1.8 * a);
    return base === 'triangle' && ecrasee ? [...entiers(0.7 * a, 0.85 * a), ...hautes] : hautes;
};

/**
 * { a, b, L } : faces équilatérales une fois sur quatre (triangle, carré),
 * isocèles sinon. `ecrasee` : la face plus basse que large est permise (pas
 * dans « Associer », dont la pyramide en perspective est dessinée haute).
 */
const tirerDims = (base, ecrasee = false) => {
    const dims = DIMS_BASE[base]();
    const L = base !== 'rectangle' && randInt(1, 4) === 1 ? dims.a : randomChoice(aretesPossibles(base, dims, ecrasee));
    return { ...dims, L };
};

/** Les faces dont le rabattement se voit. */
const facesRecouvrables = (base, dims) => [...Array(base === 'triangle' ? 3 : 4).keys()]
    .filter((face) => recouvrementVisible185({ base, ...dims, face }));

/** « à base carrée de 4 cm de côté ; ses arêtes latérales mesurent 5 cm » */
const phraseMesures = (base, { a, b, L }) => {
    const debut = base === 'rectangle' ? `à base rectangulaire de ${a} cm sur ${b} cm`
        : base === 'carre' ? `à base carrée de ${a} cm de côté`
            : `dont la base est un triangle équilatéral de ${a} cm de côté`;
    return `${debut} ; ses arêtes latérales mesurent ${L} cm`;
};

const genPatron = () => {
    // la base d'abord, les longueurs ensuite : un rejet ne change pas la part des bases
    const base = randomChoice(['triangle', 'carre', 'rectangle']);
    const n = base === 'triangle' ? 3 : 4;
    for (let essai = 0; essai < 60; essai++) {
        const dims = tirerDims(base);
        const recouvrables = facesRecouvrables(base, dims);
        // autres_mesures : le patron juste d'une AUTRE pyramide de même base (prof 2026-09-24)
        const autres = [...aretesPossibles(base, dims), ...(base !== 'rectangle' ? [dims.a] : [])].filter((l) => l !== dims.L);
        if (recouvrables.length === 0 || autres.length === 0) continue;
        const params = [
            { variante: 'correct', L: dims.L, code: null },
            { variante: 'correct', L: randomChoice(autres), code: 'autres_mesures' },
            { variante: 'manque', L: dims.L, face: randInt(0, n - 1), code: 'face_manquante' },
            { variante: 'recouvre', L: dims.L, face: randomChoice(recouvrables), code: 'recouvrement' },
        ].map((p) => ({ base, a: dims.a, b: dims.b, face: 0, ...p }));
        const options = params.map((p) => ({ svg: patronPyramide185({ ...p, codage: true, mesures: true }), code: p.code }));
        // Second chemin : un seul patron complet, sans recouvrement, de CETTE base et de CETTE arête latérale.
        const cles = options.filter((o) => o.svg.includes(`data-patron="base=${base};variante=correct;face=0;L=${dims.L}"`));
        if (cles.length !== 1 || new Set(options.map((o) => o.svg)).size !== 4) throw new Error('gen_185 patron : options');
        const sommet = 'S'; const lettres = lettresBase(n);
        const { svg, alt } = pyramideNommee185({ base, sommet, lettres });
        const images = options.map((o) => choixFigure(o.svg));
        const texte = `<p>${sommet}${lettres.join('')} est une pyramide ${phraseMesures(base, dims)}.</p><p><b>Quel est son patron ?</b></p>`;
        const payload = makeQcm(images, images[0], texte, { ...opts(L_PATRON), elements_additionnels: elementFigure(svg, alt, 'small') });
        payload._meta.params = { base, ...dims, distracteurs: options.slice(1).map((o) => o.code) };
        return payload;
    }
    throw new Error('gen_185 patron : sans tirage');
};

// ═════════ Carte « est-ce un patron ? » : QCM ═════════

const REPONSES_EST = {
    correct: 'Oui, c\'est un patron.',
    manque: 'Non : il manque une face.',
    recouvre: 'Non : deux faces se recouvrent.',
    aretes_inegales: 'Non : deux côtés qui doivent se rejoindre n\'ont pas la même longueur.',
};
const CODES_EST = { correct: 'patron_cru', manque: 'face_manquante', recouvre: 'recouvrement', aretes_inegales: 'aretes_inegales' };

const genEstPatron = () => {
    // la variante et la base d'abord, les longueurs ensuite : un rejet ne change pas
    // la part des réponses (la clé « oui » passait de 25 à 31 %)
    const variante = randomChoice(Object.keys(REPONSES_EST));
    // deux côtés inégaux : toujours la base carrée avec ses cinq faces, deux faces
    // qui se font face plus longues (prof 2026-09-24 : une seule face différente
    // se lisait « il manque sa jumelle »)
    const base = variante === 'aretes_inegales' ? 'carre' : randomChoice(['triangle', 'carre']);
    const n = base === 'triangle' ? 3 : 4;
    for (let essai = 0; essai < 60; essai++) {
        const dims = tirerDims(base, true);
        // les faces longues d'« aretes_inegales » restent sous deux fois le côté : la base reste lisible
        if (variante === 'aretes_inegales' && dims.L > 1.5 * dims.a) continue;
        let face = randInt(0, n - 1);
        if (variante === 'recouvre') {                       // une face rabattue qui se voit (sinon on croit qu'elle manque)
            const recouvrables = facesRecouvrables(base, dims);
            if (recouvrables.length === 0) continue;
            face = randomChoice(recouvrables);
        }
        const L2 = variante === 'aretes_inegales' ? Math.max(dims.L + 1, Math.round(1.4 * dims.L)) : null;
        const svg = patronPyramide185({ base, ...dims, L2, variante, face, codage: true });
        const alt = `Un dessin présenté comme un patron : une base ${NOM_BASE[base]}, en bleu, et des triangles accrochés à ses côtés ; de petits traits marquent les côtés de même longueur.`;
        const texte = `<p>Voici un dessin présenté comme le patron d'une pyramide à base ${NOM_BASE[base]}.</p>`
            + '<p><b>Est-ce un patron de pyramide ?</b></p>';
        const payload = makeQcm(Object.values(REPONSES_EST), REPONSES_EST[variante], texte,
            { ...opts(L_ESTPATRON), elements_additionnels: elementFigure(svg, alt, 'small') });
        payload._meta.params = { base, ...dims, L2, variante, face, distracteurs: Object.keys(REPONSES_EST).filter((v) => v !== variante).map((v) => CODES_EST[v]) };
        return payload;
    }
    throw new Error('gen_185 est-ce un patron : sans tirage');
};

// ═════════ Carte « le cône en perspective » : QCM d'images ═════════

const CONES_FAUX = ['cachee_pleine', 'pointilles_inverses', 'base_en_cercle', 'sommet_decale'];

const genCone = () => {
    const dims = { rx: randomChoice([52, 58, 64]), ry: randomChoice([15, 18, 21]), h: randomChoice([105, 115, 120]) };
    const faux = shuffle(CONES_FAUX).slice(0, 3);
    const images = ['correct', ...faux].map((v) => choixFigure(coneVariante(v, dims)));
    const payload = makeQcm(images, images[0],
        '<p><b>Quel dessin représente un cône de révolution en perspective cavalière ?</b></p>', opts(L_CONE));
    payload._meta.params = { dims, distracteurs: faux };
    return payload;
};

// ═════════ Contrat des distracteurs (données pures, jamais lues à l'exécution) ═════════

export const REGLES_DISTRACTEURS_QCM = {
    invariants_communs: [
        'un seul jeu de dessins par carte, sans sel (data-v masquait la variété au harnais) ; la variété vient des proportions, des lettres et des variantes',
        'chaque distracteur est une erreur NOMMÉE (codes dans _meta.params.distracteurs), jamais une option inventée',
    ],
    reconnaitre_qcm_unique: {
        support: 'clé tirée parmi pyramide (base carrée), tétraèdre, cône ; quatre solides de solide185, sans lettre ni hauteur',
        familles: {
            pointu: 'un solide qui a aussi un sommet : le cône pour une pyramide, la pyramide ou le tétraèdre pour un cône',
            triangle_vu: 'le prisme à base triangulaire : des triangles, mais deux bases et pas de sommet',
            prisme_pour_pyramide: 'un prisme à base pentagonale ou hexagonale : une base polygonale, mais deux',
            pyramide_pour_tetraedre: 'la pyramide à base carrée : une pyramide, mais sa base n\'est pas un triangle',
            base_ronde: 'le cylindre : une base en disque, mais deux et pas de sommet',
        },
        supprimees: {
            tetraedre_pour_pyramide: 'jamais le tétraèdre parmi les choix de « une pyramide » : il en est une',
        },
    },
    nature_qcm_unique: {
        support: 'SABCD à base carrée ou rectangulaire (face latérale ou base), ou GABC dans le cube du cours (ses quatre faces) ; quatre choix fixes ; la clé recalculée sur les sommets 3D du dessin',
        familles: {
            moins_precis: 'vrai mais moins précis : un triangle pour un triangle rectangle, un rectangle pour un carré (la question dit « la plus précise »)',
            angle_droit_suppose: 'un triangle rectangle pour une face latérale de SABCD : un angle droit qu\'aucune donnée n\'établit',
            face_de_l_autre_sorte: 'la forme de la base pour une face latérale, un triangle pour la base',
            forme_voisine: 'un carré pour une base rectangulaire',
            face_du_cube: 'un carré ou un rectangle pour une face de GABC : la face ou la section du cube qui la contient',
        },
    },
    patron_qcm_unique: {
        support: 'base triangulaire (équilatérale), carrée ou rectangulaire ; mesures entières en cm dans l\'énoncé et sur les quatre patrons (patronPyramide185, chacun à l\'échelle de ses mesures, codage des côtés de même longueur)',
        familles: {
            autres_mesures: 'le patron juste d\'une AUTRE pyramide de même base : l\'arête latérale n\'a pas la longueur de l\'énoncé ; il faut lire les mesures pour l\'écarter, PRINCIPALE (prof 2026-09-24, « aller plus loin sur un distracteur »)',
            face_manquante: 'une face latérale de moins, les bonnes mesures',
            recouvrement: 'une face rabattue sur la base, les bonnes mesures',
        },
        supprimees: {
            pave_cylindre: 'le patron d\'un pavé et celui d\'un cylindre s\'éliminaient sans regarder (seules deux options sur quatre avaient une base bleue, 100 %)',
            nombre_de_triangles: 'le patron d\'une base qui n\'a pas le même nombre de côtés s\'écartait au premier coup d\'œil ; remplacé par autres_mesures (2026-09-24)',
        },
    },
    estpatron_qcm_unique: {
        support: 'base triangulaire ou carrée, codage des côtés de même longueur, faces isocèles (équilatérales une fois sur quatre) ; quatre réponses fixes ; aretes_inegales toujours sur la base carrée, ses cinq faces, deux faces qui se font face plus longues',
        familles: {
            patron_cru: '« oui » devant un dessin qui ne se plie pas',
            face_manquante: '« il manque une face » quand rien ne manque',
            recouvrement: '« deux faces se recouvrent » quand aucune ne se recouvre',
            aretes_inegales: '« deux côtés n\'ont pas la même longueur » quand ils l\'ont',
        },
    },
    cone_qcm_unique: {
        support: 'quatre dessins du même cône (coneVariante), mêmes traits et même taille : le juste et trois des quatre faux',
        familles: {
            cachee_pleine: 'toute la base en trait plein : la moitié cachée n\'est pas en pointillés',
            pointilles_inverses: 'la moitié avant en pointillés et l\'arrière en plein',
            base_en_cercle: 'la base dessinée en cercle : la vue de dessus mêlée à la perspective',
            sommet_decale: 'le sommet hors de l\'aplomb du centre : plus un cône de révolution',
        },
    },
};

// ═════════ Registre et exports ═════════

const GENERATORS = {
    reconnaitre_qcm_unique: genReconnaitre,
    nature_qcm_unique: genNature,
    patron_qcm_unique: genPatron,
    estpatron_qcm_unique: genEstPatron,
    cone_qcm_unique: genCone,
};

const LABELS_FORMAT = {
    reconnaitre_qcm_unique: 'QCM images', nature_qcm_unique: 'QCM', patron_qcm_unique: 'QCM images',
    estpatron_qcm_unique: 'QCM', cone_qcm_unique: 'QCM images',
};
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter((k) => k.startsWith(`${prefix}_`))
        .map((k) => ({ key: k, label: LABELS_FORMAT[k] || k }));

export const CATEGORIES = [
    { id: 'reconnaitre', label: L_RECONN, formatsList: buildFormats('reconnaitre') },
    { id: 'nature', label: L_NATURE, formatsList: buildFormats('nature') },
    { id: 'patron', label: L_PATRON, formatsList: buildFormats('patron') },
    { id: 'estpatron', label: L_ESTPATRON, formatsList: buildFormats('estpatron') },
    { id: 'cone', label: L_CONE, formatsList: buildFormats('cone') },
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};

export const _internals = { GENERATORS };
